module.exports = __webpack_public_path__ + "img/header-weddingRingsCeramic.8d65b16.jpg";